import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollTo = (href: string) => {
    if (href.startsWith('#')) {
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { labelKey: 'nav.about', href: '#about' },
    { labelKey: 'nav.services', href: '#services' },
    { labelKey: 'nav.contracts', href: '#contracts' },
    { labelKey: 'nav.profit', href: '#profit' },
  ];

  const legalLinks = [
    { labelKey: 'footer.terms', href: '#' },
    { labelKey: 'footer.privacy', href: '#' },
    { labelKey: 'footer.tax', href: '#' },
  ];

  const socials = [
    { icon: 'ri-twitter-x-line', label: 'Twitter', href: '#' },
    { icon: 'ri-telegram-line', label: 'Telegram', href: '#' },
    { icon: 'ri-discord-line', label: 'Discord', href: '#' },
  ];

  return (
    <footer className="bg-[#050508] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2">
            <div className="flex items-center gap-3 mb-5 md:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl">
                <i className="ri-rocket-fill text-black text-xl md:text-2xl"></i>
              </div>
              <div>
                <div className="font-['Orbitron'] text-white font-black text-lg md:text-xl tracking-wider">SPACEX</div>
                <div className="text-amber-400 text-xs font-['Rajdhani'] uppercase tracking-[0.2em]">IPO 2025</div>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-md font-['Rajdhani'] mb-5 md:mb-6">
              {t('footer.desc')}
            </p>
            <div className="flex gap-2.5 md:gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-white/5 hover:bg-amber-500/20 border border-white/10 hover:border-amber-500/30 rounded-xl text-gray-400 hover:text-amber-400 transition-all duration-200"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-base md:text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Nav Links */}
          <div>
            <div className="font-['Orbitron'] text-white font-bold text-sm mb-5 md:mb-6 tracking-wider">{t('footer.nav')}</div>
            <ul className="space-y-2.5 md:space-y-3">
              {navLinks.map((l) => (
                <li key={l.labelKey}>
                  <button
                    onClick={() => scrollTo(l.href)}
                    className="text-gray-500 hover:text-amber-400 text-sm font-['Rajdhani'] transition-colors cursor-pointer"
                  >
                    {t(l.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="font-['Orbitron'] text-white font-bold text-sm mb-5 md:mb-6 tracking-wider">{t('footer.legal')}</div>
            <ul className="space-y-2.5 md:space-y-3">
              {legalLinks.map((l) => (
                <li key={l.labelKey}>
                  <button
                    onClick={() => scrollTo(l.href)}
                    className="text-gray-500 hover:text-amber-400 text-sm font-['Rajdhani'] transition-colors cursor-pointer"
                  >
                    {t(l.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-16 pt-6 md:pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-3 md:gap-4">
          <div className="text-gray-600 text-xs font-['Rajdhani'] text-center sm:text-left">{t('footer.copy')}</div>
          <div className="text-gray-600 text-xs font-['Rajdhani'] text-center sm:text-right">{t('footer.disclaimer')}</div>
        </div>
      </div>
    </footer>
  );
}